// extracted by mini-css-extract-plugin
export var cardHeader = "_to-0";
export var reorderHandle = "_to-3";
export var titleArea = "_to-1";
export var titleAreaWithHandle = "_to-2";